import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-custom-radio",
  templateUrl: "./custom-radio.component.html",
  styleUrls: ["./custom-radio.component.scss"],
  standalone: false,
})
export class CustomRadioComponent {
  @Input() id!: string;
  @Input() name!: string;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() value: any;

  @Output() change = new EventEmitter<Event>(); // Emits change event

  onChange(event: Event) {
    this.change.emit(event);
  }
}
